import { Button, Modal, Form, Input, message, Select } from "antd";
import API from "../../../../services/api-request";
import SelectWarehouse from "../../../../components/SelectWarehouse";
import { useState } from "react";

const AddArea = (props) => {
  const [addForm] = Form.useForm();
  const [formData, setFormData] = useState({
    warehouse: "",
    row: "",
    section: "",
    column: "",
    level: "",
    areaName: "",
  });

  const handleChange = (key) => (valueOrEvent) => {
    const value =
      valueOrEvent && valueOrEvent.target
        ? valueOrEvent.target.value // for Input
        : valueOrEvent; // for Select

    const newAreaName = autoFillAreaName(key, value, formData);

    setFormData((prev) => ({
      ...prev,
      [key]: value,
      areaName: newAreaName,
    }));
  };

  const handleWarehouseChange = (value, options) => {
    const warehouseLabel = options.label;
    const newAreaName = autoFillAreaName("warehouse", warehouseLabel, formData);

    setFormData((prev) => ({
      ...prev,
      warehouse: warehouseLabel,
      areaName: newAreaName,
    }));
  };

  const autoFillAreaName = (key, value, currentData) => {
    const updatedData = {
      ...currentData,
      [key]: value,
    };

    const warehouse = updatedData.warehouse
      ? updatedData.warehouse.includes("Temporary")
        ? "T-CS" + updatedData.warehouse.split(" ")[2]
        : "CS" + updatedData.warehouse.split(" ")[2]
      : "";

    const row = updatedData.row || "";
    const section = updatedData.section || "";
    const column = updatedData.column || "";
    const level = updatedData.level || "";

    const areaName = `${warehouse}-${row}${section}-${column}${level}`;

    addForm.setFieldValue("name", areaName);
  };

  const onFinish = async (values) => {
    const { name, warehouse_id, section, column_name, row_number, level } =
      values;

    const dataForm = {
      name,
      warehouse_id,
      section,
      column_name,
      row_number,
      level,
    };

    await API.Post("area", dataForm)
      .then(() => {
        message.success("Area has been added");
        props.onGetArea();
        addForm.resetFields();
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      })
      .finally(() => {
        setFormData({
          warehouse: "",
          row: "",
          section: "",
          column: "",
          level: "",
          areaName: "",
        });
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setFormData({
      warehouse: "",
      row: "",
      section: "",
      column: "",
      level: "",
      areaName: "",
    });
  };

  const handleCancel = () => {
    setFormData({
      warehouse: "",
      row: "",
      section: "",
      column: "",
      level: "",
      areaName: "",
    });
    props.onShowAdd(false);
    addForm.resetFields();
  };

  const sectionOptions = [
    {
      label: "A",
      value: "A",
    },
    {
      label: "B",
      value: "B",
    },
  ];

  const columnOptions = [
    {
      label: "X",
      value: "X",
    },
    {
      label: "Y",
      value: "Y",
    },
    {
      label: "Z",
      value: "Z",
    },
  ];

  return (
    <>
      <Modal
        title="Add Area"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Warehouse"
            name="warehouse_id"
            rules={[{ required: true, message: "Please input Warehouse!" }]}
          >
            <SelectWarehouse
              onChange={(value, options) => {
                handleWarehouseChange(value, options);
              }}
            />
          </Form.Item>

          <Form.Item
            label="Row Number"
            name="row_number"
            rules={[
              { required: true, message: "Please input row_number!" },
              {
                pattern: /^\d+$/,
                message: "Please enter a valid number!",
              },
            ]}
          >
            <Input
              placeholder="Input Row Number"
              onChange={handleChange("row")}
            />
          </Form.Item>

          <Form.Item
            label="Section"
            name="section"
            rules={[{ required: true, message: "Please input section!" }]}
          >
            <Select
              options={sectionOptions}
              placeholder="Select Section"
              onChange={handleChange("section")}
            />
          </Form.Item>

          <Form.Item
            label="Column Name"
            name="column_name"
            rules={[{ required: true, message: "Please input column name!" }]}
          >
            <Select
              options={
                formData?.warehouse?.includes("Temporary")
                  ? [{ label: "T", value: "T" }]
                  : formData?.warehouse === "Cold Storage 2"
                  ? [{ label: "S", value: "S" }, ...columnOptions]
                  : columnOptions
              }
              placeholder="Select Column"
              onChange={handleChange("column")}
            />
          </Form.Item>

          <Form.Item
            label="Level"
            name="level"
            rules={[
              { required: true, message: "Please input level!" },
              {
                pattern: /^\d+$/,
                message: "Please enter a valid number!",
              },
            ]}
          >
            <Input placeholder="Input Level" onChange={handleChange("level")} />
          </Form.Item>

          <Form.Item
            label="Area Name"
            name="name"
            rules={[{ required: true, message: "Please input area name!" }]}
          >
            <Input placeholder="Input Area Name" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddArea;
